import { PlayButton } from '@southfields-digital/mpxlive-components';
import classNames from 'classnames';

import styles from '../MatchControl.module.scss';

type ClockStartProps = {
  isRunning: boolean;
  handleStartTimer: () => void;
  handleStopTimer: () => void;
  minimize?: boolean;
};

const ClockStart = ({
  isRunning,
  handleStartTimer,
  handleStopTimer,
  minimize,
}: ClockStartProps) => (
  <div className={classNames(styles.ActionsWrapper, minimize && 'gap-1.5')}>
    <PlayButton
      hasIcon
      isRunning={isRunning}
      onClick={handleStartTimer}
      iconProps={{ icon: 'play', weight: 'bold', size: minimize ? 18 : 24 }}
      className={classNames(
        'place-content-center transition-all duration-150 ease-out',
        minimize ? '!h-7 !w-12' : '!h-9 !w-16',
        !isRunning && '!bg-gray-800 !border-none !bg-none rounded-sm'
      )}
    />
    <PlayButton
      hasIcon
      isRunning={!isRunning}
      onClick={handleStopTimer}
      className={classNames(
        'place-content-center transition-all duration-150 ease-out',
        minimize ? '!h-7 !w-12' : '!h-9 !w-16',
        isRunning && '!bg-gray-800 !border-none !bg-none rounded-sm'
      )}
      iconProps={{ icon: 'pause', weight: 'bold', size: minimize ? 18 : 24 }}
    />
  </div>
);

export default ClockStart;
